import { debug } from "console";
import React, { useState } from "react";
import { Link } from "react-router-dom"; 
import LogoDark from "../images/logo/logo-dark.png"; 
import Logo from "../images/logo/logo.png";
import authService from "../services/authService";


const RecuperarContrasena = () => {
    const [email, setEmail] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [mensaje, setMensaje] = useState<string>("");

    // ===== Clases reutilizadas =====
    const inputClass =
        "w-full rounded-lg border border-stroke bg-transparent py-4 pl-6 pr-4 text-black outline-none focus:border-primary focus-visible:shadow-none dark:border-form-strokedark dark:bg-form-input dark:text-white placeholder:text-gray-400";

    const labelClass =
        "mb-2.5 block text-sm font-medium text-black dark:text-white";

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setMensaje("");

        try {
            const response = await authService.forgotPassword(email);

            if (response?.success) {
                setMensaje(
                    "Te enviamos un correo con las instrucciones para restablecer tu contraseña."
                );
            } else {
                setMensaje(response?.errors?.[0] || "No se pudo procesar la solicitud");
            }
        } catch (error: any) {
            setMensaje(
                error?.message || "Error de comunicación con el servidor"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
            {/* ================= IZQUIERDA ================= */}
            <div className="hidden lg:flex flex-col justify-center items-center text-center gap-6 px-16 py-12 bg-white border-r border-stroke dark:border-strokedark">
                <div>
                    <div className="flex justify-center">
                        <Link to="/">
                            <img className="hidden dark:block" src={Logo} alt="Logo" />
                            <img className="dark:hidden" src={LogoDark} alt="Logo" />
                        </Link>
                    </div>

                    <p className="mt-4 text-gray-600 2xl:px-40">
                        Recuperá el acceso a tu cuenta de forma segura
                    </p>
                </div>
            </div>

            {/* ================= DERECHA ================= */}
            <div className="flex items-center justify-center px-6">
                <div className="w-full max-w-md">
                    <h1 className="text-3xl font-semibold mb-2">
                        Recuperar contraseña
                    </h1>
                    <p className="text-gray-500 mb-8">
                        ¿Olvidaste tu contraseña? Ingresá tu correo y te enviaremos
                        instrucciones para restablecerla. Revisá tambien la carpeta de spam.
                    </p>

                    <form className="space-y-5" onSubmit={handleSubmit}>
                        <div>
                            <label className={labelClass}>Correo electrónico</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Ingresá tu correo"
                                className={inputClass}
                                required
                            />
                        </div>

                        {mensaje && (
                            <p className="text-sm text-center text-primary">
                                {mensaje}
                            </p>
                        )}

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-primary text-white py-3 rounded-lg font-medium hover:bg-primary/90 transition disabled:opacity-60"
                        >
                            {loading ? "Enviando..." : "Enviar instrucciones"}
                        </button>
                    </form>

                    <p className="text-sm text-center mt-6">
                        ¿Recordaste tu contraseña?{" "}
                        <Link to="/auth/signin" className="text-primary font-medium">
                            Ingresar
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default RecuperarContrasena;
